import type { Messages } from './en';

/** Fase A: el pasaporte de inglés y el tutorial de la primera partida. */
export const esGuide: Pick<Messages, 'passport' | 'tutorial'> = {
  passport: {
    title: '🛂 Pasaporte de inglés',
    tool: 'Pasaporte',
    levels: ['Principiante', 'A1 Explorador', 'A2 Viajero', 'B1 Hablante', 'B1+ Estrella', 'B2 Campeón'],
    xp: (n: number) => `${n} XP`,
    next: (n: number) => `${n} XP para el siguiente nivel`,
    top: '¡Has llegado al nivel máximo, increíble!',
    levelUp: (name: string) => `🎉 Nuevo nivel de inglés: ¡${name}!`,
    newStamp: '🛂 ¡Nuevo sello en tu pasaporte de inglés!',
    stats: {
      known: 'Palabras vistas',
      mastered: 'Dominadas',
      spelled: 'Deletreadas',
      shadowed: 'Dichas en voz alta',
      talks: 'Diálogos',
      stories: 'Cuentos',
      stamps: 'Sellos',
    },
    talkStamps: 'Sellos de diálogos',
    placeStamps: 'Lugares y fiestas',
    notYet: 'Aún no',
    week: 'Tus últimos días',
    legend: { words: 'palabras', talks: 'diálogos', spells: 'deletreo' },
    day: (n: number) => `D${n}`,
    parents: '👨‍👩‍👧 Para los mayores',
    parentsHint: 'Lo que ha practicado tu hijo o hija. Las palabras de «sigue practicando» vuelven en el repaso hasta que se quedan.',
    strong: 'Palabras fuertes',
    weak: 'Sigue practicando',
    none: 'Nada todavía',
    practise: '🎤 Ir al rincón de inglés',
    stampNames: {
      nightMarket: 'Mercado nocturno',
      lantern: 'Fiesta de los Faroles',
      dragonBoat: 'Barcos Dragón',
      moon: 'Fiesta de la Luna',
      newYear: 'Año Nuevo Chino',
      taipei101: 'Taipei 101',
      mrt: 'Metro de Taipéi',
      museum: 'Museo del Palacio Nacional',
      taroko: 'Garganta de Taroko',
      beach: 'Playa de Qixingtan',
      jiufen: 'Calle vieja de Jiufen',
      xiangshan: "Montaña del Elefante",
      ximen: "Ximending",
      longshan: "Templo de Longshan",
      cks: "Memorial de Chiang Kai-shek",
      beitou: "Termas de Beitou",
      dongdamen: "Mercado nocturno de Dongdamen",
      jian: "Ji'an",
    },
  },
  tutorial: {
    skip: 'Saltar',
    next: 'Siguiente ›',
    back: '‹ Atrás',
    done: '▶ ¡A jugar!',
    menu: '❓ Cómo se juega',
    steps: [
      { title: '¡Bienvenido!', text: 'Este es tu pueblo en Taiwán. Vive tus días de cole, ayuda a la gente… y aprende inglés por el camino.' },
      { title: 'Muévete', text: 'Usa las flechas o toca cualquier punto del mapa para ir andando hasta allí.' },
      { title: 'Habla y usa cosas', text: 'Cuando estés al lado de alguien o de algo, este botón se ilumina. Tócalo para hablar, comprar, jugar…' },
      { title: '¡Salta!', text: 'Salta setos, vallas y arbustos. Algunos secretos solo se alcanzan de un salto.' },
      { title: 'Qué hacer ahora', text: 'Tu próximo objetivo siempre aparece aquí, y una flecha dorada en el mapa te marca el camino.' },
      { title: 'Tu diario', text: 'Aquí están los objetivos de hoy, los capítulos de la historia y todas las misiones. Quien lleve un ❗ sobre la cabeza tiene algo para ti.' },
      { title: 'Tu móvil', text: 'Chats, llamadas, PixelBook, la radio… y todas las herramientas: practicar inglés, la recreativa, la búsqueda del tesoro, tu pasaporte. ¡Cuidado con las estafas!' },
      { title: 'El menú', text: 'Aquí puedes pausar, cambiar el idioma, quitar el sonido o guardar la partida. ¡Que te diviertas!' },
    ],
  },
};
